import ManageOffices from './ManageOffices';
import Route from './route';

export default {
  RenderProp: ManageOffices,
  mainRoute: Route,
};
